export default __webpack_public_path__ + "static/media/icon_share-this-linkedin.c2e05ac9.svg";